.checkbox {
  display: block;
  color: var(--ns-color-black);
  position: relative;
  padding-left: var(--ns-space-5);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox > input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: var(--ns-space-05);
  top: var(--ns-border-width-thin);
  width: var(--ns-width-input-checkbox-tick);
  height: var(--ns-height-input-checkbox-tick);
  border: solid var(--ns-color-white);
  border-width: 0 var(--ns-border-width-medium) var(--ns-border-width-medium) 0;
  transform: rotate(45deg);
}

.checkbox > input:checked ~ .checkmark {
  background-color: var(--ns-color-primary);
  border-color: var(--ns-color-primary);
}

.checkbox > input:checked ~ .checkmark:after {
  display: block;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: var(--ns-height-input-checkbox);
  width: var(--ns-height-input-checkbox);
  background-color: var(--ns-color-white);
  border: var(--ns-border-width-thin) solid #999;
  border-radius: var(--ns-border-radius-3);
}
